module.exports = __webpack_public_path__ + "img/arrow4.f74c0c2a.svg";